import React from 'react';

import { Box } from 'ui/box';

interface VideoComponentProps {
  src?: string;
}

const VideoComponent = ({
  src = '',
}: VideoComponentProps): React.JSX.Element => (
  <Box
    sx={{
      width: '100%',
      '@media (min-width: 375px)': { mb: 3 },
      '@media (min-width: 960px)': { mb: 4 },
    }}
  >
    {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
    <video src={src} className="flex h-auto w-full" controls />
  </Box>
);

export default VideoComponent;
